import { NavLink, useNavigation , Link} from 'react-router-dom'
import Button, { ButtonProps } from '@mui/material/Button';

const Navbar = (props) => {
    // console.log('navbar',props);
    var signOut = props.props.signout;
    var isAdmin = props.props.isAdmin;
    const { state } = useNavigation();

    return (
        <>
        {state.loading === "loading" ? <div>Loading....</div> :
        <nav className='navbar'>

        <NavLink to="switches" style={{ padding: 5 }}>Switches</NavLink>  
        <NavLink to="settings" style={{ padding: 5 }}>Settings</NavLink> 
        <NavLink to="monitor" style={{ padding: 5 }}>Monitor</NavLink>      
        <NavLink to="rack" style={{ padding: 5 }}>Rack</NavLink>            
       

        { isAdmin ?
        <NavLink to='admin/joiner' style={({ isActive })=>{
            return {padding:5, color:isActive?'red':'grey'};
        }}>Settings</NavLink>
        :<></>}

        { isAdmin ?
            <NavLink to='admin/invite' className='btn' style={({ isActive })=>{
            return {padding:5, color:isActive?'red':'grey'};
        }}>Invite</NavLink>
        :<></>}

        { isAdmin ?
        <NavLink to='admin/users'  style={({ isActive })=>{
            return {padding:5 , color:isActive?'red':'grey'};
        }}>Users</NavLink>
        :<></>}
        <Link onClick={signOut} className="signOutButton">SignOut</Link>
        <NavLink to="dashboard" style={{ padding: 5 }}>debug</NavLink>
        </nav>
        }
        </>
    );
};

export default Navbar;